module.exports = __webpack_public_path__ + "img/ic-home.adf0e88f.svg";